export type CloudState = 'idle' | 'loading' | 'saving' | 'synced' | 'local-only' | 'error';

export interface CloudStatus {
  state: CloudState;
  /** Plain-language detail shown beside the indicator. */
  message: string;
  /** When the last successful cloud save or load happened. */
  at: string | null;
}

export const cloudStatusEvent = 'artistos:cloud-status';

let current: CloudStatus = { state: 'idle', message: '', at: null };

export function getCloudStatus(): CloudStatus {
  return current;
}

export function setCloudStatus(state: CloudState, message = '') {
  current = {
    state,
    message,
    at: state === 'synced' ? new Date().toISOString() : current.at,
  };
  try {
    window.dispatchEvent(new CustomEvent<CloudStatus>(cloudStatusEvent, { detail: current }));
  } catch {
    // Nothing listening yet.
  }
}

/** Subscribes to cloud sync changes and returns the unsubscribe function. */
export function onCloudStatusChange(handler: (status: CloudStatus) => void): () => void {
  const listener = (event: Event) => handler((event as CustomEvent<CloudStatus>).detail ?? current);
  window.addEventListener(cloudStatusEvent, listener as EventListener);
  return () => window.removeEventListener(cloudStatusEvent, listener as EventListener);
}
